import callApi from './personnelService';
import { buildQueryUrlFromObject } from '../../helper/buildQueryUrlFromObject';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}/sic`;

export const getStores = (storeInfo) => callApi({
  method: 'GET',
  endpoint: `${basePath}/stores`,
  body: storeInfo
});

export const getIndexSa = (storeInfo) => callApi({
  method: 'GET',
  endpoint: `${basePath}/sa?${buildQueryUrlFromObject(storeInfo)}`
});

export const getIndexCustomer = (storeInfo) => callApi({
  method: 'GET',
  endpoint: `${basePath}/member?${buildQueryUrlFromObject(storeInfo)}`
});

export const getIndexReservation = (storeInfo) => callApi({
  method: 'GET',
  endpoint: `${basePath}/reserve?${buildQueryUrlFromObject(storeInfo)}`
});

export const getStorePersonnel = (store_id) => callApi({
  method: 'POST',
  endpoint: `${basePath}/get-store-personnel`,
  body: {
    store_id
  }
});

export const updateSa = (updateInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/store-manage/update-sa/${updateInfo.sa_id}`,
  body: updateInfo
});
